import * as Sentry from "@sentry/react-native";

type LogContext = Record<string, unknown>;

type LogLevel = "debug" | "info" | "warn" | "error";

function devLog(
  level: LogLevel,
  namespace: string | null,
  message: string,
  context?: LogContext
) {
  if (__DEV__) {
    const prefix = namespace ? `[${namespace}]` : "";
    const fn = console[level] ?? console.log;
    fn(`${prefix}[${level.toUpperCase()}] ${message}`, context ?? "");
  }
}

function createLogMethods(namespace: string | null) {
  return {
    debug(message: string, context?: LogContext) {
      devLog("debug", namespace, message, context);
      Sentry.logger.debug(message, context);
    },
    info(message: string, context?: LogContext) {
      devLog("info", namespace, message, context);
      Sentry.logger.info(message, context);
    },
    warn(message: string, context?: LogContext) {
      devLog("warn", namespace, message, context);
      Sentry.logger.warn(message, context);
    },
    error(message: string, error?: unknown, context?: LogContext) {
      devLog("error", namespace, message, { ...context, error });
      Sentry.logger.error(message, context);
      if (error) {
        Sentry.captureException(error, { extra: context });
      }
    },
  };
}

export const logger = {
  ...createLogMethods(null),
  create(namespace: string) {
    return createLogMethods(namespace);
  },
};
